import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { http } from "../../../service/http";
import { DELETE_PATIENT_URL, FETCH_PATIENT_LIST_BY_PRACTICE_ID, FETCH_PATIENTLIST_URL, FETCH_PATIENT_URL, GET_PATIENT_DETAILS_WITH_ACTIVE_PATIENT_INFO } from "../../../service/URL";
import { useAppSelector } from "../redux-hooks";
import { LoadingType } from "../../../types/CommonTypes";
import { PracticeInfo } from "../practiceSlice";
import { checkPatient, fetchPatientEligibilty, fetchPatientsByUserRole, getActivePatientBeneficationInsruanceSummary, getActivePatientBeneficationSummary, getPatientBeneficationSummary, getPatientDocumentsByDocumentIds,addPatientByEmrCheck, inactivateWoundInfo, patientSearchService, savePatient, savePatientBeneficationData, saveWoundData, updatepatintAddress, woundInfoIvrAvailability, getSurgicalTemplateBasedOnProviderId,updatePatientStatus, fetchPatientListforFilter, fetchSurgicalTemplateByTemplateId, fetchPrescriptionsByPatientId, fetchPrescriptionsByProductIdAndPatientId } from "../../../service/PatientService";
import { updateElementValue } from "../../../utils/updateElementValue";

type PatientInfoResponse = {
  code: Number,
  message: string,
  data: PatientInfo[],
};
export type PatientDocumentInfo = {
  ivrId: any;
  documentId?: number;
  documentName: string;
  content: string;
  documentType?: string;
  type?: string;
  fileType: string;
  auditTimestamp?: string;
};

export type SearchInfo = {
  name: string,
  address: string,
  unitNumber: string,
  city: string,
  state: string,
  primaryInsurance: string,
  secondaryInsurance: string,
  practiceName: string,
};

export type SearchPatientRequest = {
  firstName: string,
  lastName: string,
  // primaryInsurance: string,
  // secondaryInsurance: string,
  isSurgicalPracticesAvailable: boolean,
  patientStatus:string[]
  practiceIds: number[],
  currentPage: number;
  itemsPerPage: number;
  sortBy?: "patientCode" | "patientName" | "practiceName" | "birthDate" | "dateOfSurgery" | "status";
  sortOrder?: "asc" | "desc";
};

export type NameInfoState = {
  firstName: string,
  middleName: string,
  lastName: string,
}

export type PatientAddressInfo = {
  patientStreetAddress: string;
  patientUnitNumber: string;
  patientCity: string;
  patientState: string;
  patientZip: string;
}

export type PatientInfo = {
  patientId: number,
  patientCodeLink?: string | JSX.Element, //CS-1406
  name: NameInfoState,
  address: string,
  unitNumber: string,
  city: string,
  state: string,
  zip: string,
  primaryInsurance: string,
  secondaryInsurance: boolean,
  practiceId: number | null,
  specialization: string | null,
  providerId: number | null,
  providerTemplateId: number | null,
  practiceName: string,
  firstName: string,
  middleName: string,
  lastName: string,
  nameList: any[],
  birthDate: string,
  dateOfSurgery: string,
  gender: string,
  addressInfo?: PatientAddressInfo | null,
  status: string | null,
  patientName: string | null,
  patientInfo: any[],
  patientCode: string,
  patientEmail: string,
  isAutoPverify?: boolean;//CS-1607
  isAutoPverifyPrimary?: boolean;//CS-1607
  isAutoPverifySecondary?: boolean;//CS-1607
  npi?: string;//CS-1607
  billingType?: string;//CS-1607
  source?: string; // CS-1758 - Patient creation source (MANUAL or FACESHEET)
  insuranceInfo: {
    insuranceName: string;
    insurancePayerCode: string;
    policy: string;
    isPolicyUnderDifferentName: boolean;
    policyholderFirstName: string;
    policyholderMiddleName: string;
    policyholderLastName: string;
    policyHolderDOB: string;
    insuranceType: string;
    insuranceCards: number[];
    isInsuranceCardsSkipped: boolean;
    isSecondaryInsurance: boolean;
    secondaryInsuranceName: string;
    secondaryInsurancePayerCode: string;
    secondaryPolicy: string;
    isSecondaryPolicyUnderDifferentName: boolean;
    secondarypolicyholderFirstName: string;
    secondarypolicyholderMiddleName: string;
    secondarypolicyholderLastName: string;
    secondaryPolicyHolderDOB: string;
    secondaryInsuranceType: string;
    secondaryInsuranceCards: number[];
    isSecondaryInsuranceCardsSkipped: boolean;
  };
};

export interface PaginationSearchList {
  content: PatientInfo[];
  totalElements: number;
  totalPages: number;
  size: number;
}

export type AddPatientByEMRCheck={
  practiceId: number | null;
  providerId: number | null;
  providerTemplateId: number | null;
  firstName: string | null;
  lastName: string | null;
  dateOfBirth: string | null;
  dateOfSurgery?: string | null;
  emrProviderPracticeId?: string | null;
  emrIntegrationProvider?: string | null;
  providerName?: string | null;
  isAutoIVREnabled?: boolean | null;
  practiceSpecialization?: string | null;
}
export type SurgicalTemplateOptions={
  templateId: number | null;
  providerId: number | null;
  procedureName: string | null;
  inactiveDate: string | null;
}|[]

export type SurgicalTemplateJSON = {
  incisionId: string,
  dx: string,
  depth: string,
  width: string,
  length: string,
  daysPrescribed: string,
  primaryDressing: string,
  ancillaryDressing: string,
  secondaryDressing: string
}

export type SurgicalTemplate={
  templateId: number | null;
  providerId: number | null;
  procedureName: string | null;
  inactiveDate: string | null;
  templateJson: any | null;
}

export type PatientInfoObject = {
    patientInfo: {
        patientId: number;
        FirstName: string;
        MiddleName: string;
        LastName: string;
        patientDOB: string;
        gender: string;
        StreetAddress: string;
        UnitNumber: string;
        City: string;
        State: string;
        Zipcode: string;
        faceSheet: number[];
        patientCode: string;
        isFaceSheetSkipped: boolean;
        patientEmail: string;
    };
    insuranceInfo: {
        insuranceName: string;
        primaryCommercialInsuranceName?: string;
        insuranceNameNotListed?: boolean;
        insurancePayerCode: string;
        insuranceCategory: string;
        policy: string;
        isPolicyUnderDifferentName: boolean;
        policyholderFirstName: string;
        policyholderMiddleName: string;
        policyholderLastName: string;
        policyHolderDOB: string;
        insuranceType: string;
        insuranceCards: number[];
        isInsuranceCardsSkipped: boolean;
        isSecondaryInsurance: boolean;
        secondaryInsuranceName: string;
        secondaryInsuranceNameNotListed?:boolean;
        secondaryCommercialInsuranceName?: string;
        secondaryInsuranceCategory: string;
        secondaryInsurancePayerCode: string;
        secondaryPolicy: string;
        isSecondaryPolicyUnderDifferentName: boolean;
        secondarypolicyholderFirstName: string;
        secondarypolicyholderMiddleName: string;
        secondarypolicyholderLastName: string;
        secondaryPolicyHolderDOB: string;
        secondaryInsuranceType: string;
        secondaryInsuranceCards: number[];
        isSecondaryInsuranceCardsSkipped: boolean;
    };
    supportingDocumentation: {
        supportingDocuments: number[];
        isSupportingDocumentsSkipped: boolean;
        imageOfWounds: number[];
        isImageOfWoundsSkipped: boolean;
    };
    woundInfo: {
      woundData: {
        woundType: string;
        cpt: string;
        lCode: string;
        eCode: string;
        iCode: string;
        otherDxCodes: string;
        noOfApplications: string;
        totalSize: string;
      }[];
      totalSizeOfAllWounds: string;
    }
    practiceId: number | null;
    dateOfSurgery: string | null;
    providerId: number | null;
    providerTemplateId?: number | null

}

export type SavePatientRequest = {
    practiceId: number | null,
    dateOfSurgery: string | null,
    providerId: number | null,
    providerTemplateId: number | null,
    patientDataRequest: PatientRequest
}

export type CheckPatientRequest = {
  practiceId: number | null,
  firstName: string;
  lastName: string;
  dateOfBirth: string;
}

export type SaveWoundInfoRequest = {
  patientId: number;
  woundInfo: WoundData;
}
export type PatientStatus = {
  patientId: number;
  status: string;
}

export type WoundData = {
  infoType: string;
  isEdited: boolean;
  patientinfoId: number | null;
  infoTypeData: Object
}

export type PatientRequest = {
    patientCode: string;
    patientId: number;
    practiceId?: number;
    isPatientEdited: boolean;
    firstName: string;
    status?: string;
    middleName: string;
    lastName: string;
    birthDate: string;
    gender: string;
    patientInfo: {
      infoType: string;
      isEdited: boolean;
      patientinfoId: number | null;
      patientInfoData?: {
        patientStreetAddress: string;
        patientUnitNumber: string;
        patientCity: string;
        patientState: string;
        patientZip: string;
      };
      primaryInsuranceData?: {
        insuranceName: string;
        policy: string;
        isPolicyUnderDifferentName: boolean;
        policyHolderFirstName: string;
        policyHolderMiddleName: string;
        policyHolderLastName: string;
        policyHolderDOB: string;
        insuranceType: string;
        documentIds: number[];
      };
      secondaryInsuranceData?: {
        secondaryInsuranceName: string;
        secondaryPolicy: string;
        isSecondaryPolicyUnderDifferentName: boolean;
        secondaryPolicyHolderFirstName: string;
        secondaryPolicyHolderMiddleName: string;
        secondaryPolicyHolderLastName: string;
        secondaryPolicyHolderDOB: string;
        secondaryInsuranceType: string;
        documentIds: number[];
      };
      documentIds?: number[];
    }[];
  };

  type WoundInfoHasIvrByPatient = {
    woundInfoKey: string,
    hasIvr: boolean
  };

  type patientBeneficationSummaryData = {
    requestedDateTime : string;
    subscriber : string;
    insurance : string;
    policyNo : string;
  }

  type patientBeneficationInsuranceSummaryData = {
    bvsId:string|number;
    eligibilitySummary:{
      coInsurance: string|null;
      status: string|null;
      //CS-1170 - START
      effectiveDate: string|null;
      //CS-1170 - END
      insuranceCompanyName: string|null;
      policy: string|null;
      isHMOPlan: boolean;
      partBDeductible: string|null;
      partBDeductibleRemaining: string|null;
      pdfDocId: number|null;
      policyType: string|null;
      requestId: number|null;
      individualDeductibleInNet:string|null;
      individualDeductibleRemainingInNet:string|null;
      familyDeductibleInNet:string|null;
      familyDeductibleRemainingInNet:string|null;
      individualOOP_InNet:string|null;
      individualOOPRemainingInNet:string|null;
      familyOOPInNet:string|null;
      familyOOPRemainingInNet:string|null;
    };
   
    patientName: string|null;
    patientId: number|null;
    recursive:{
      coInsurance: string|null;
      insuranceCompanyName: string|null;
      policy: string|null;
      isHMOPlan: boolean;
      partBDeductible: string|null;
      partBDeductibleRemaining: string|null;
      pdfDocId: number|null;
      policyType: string|null;
      status: string|null;
      //CS-1170 - START
      effectiveDate: string|null;
      //CS-1170 - END
      individualDeductibleInNet:string|null;
      individualDeductibleRemainingInNet:string|null;
      familyDeductibleInNet:string|null;
      familyDeductibleRemainingInNet:string|null;
      individualOOP_InNet:string|null;
      individualOOPRemainingInNet:string|null;
      familyOOPInNet:string|null;
      familyOOPRemainingInNet:string|null;
    } | null;
  }

export type PracticeLocationDTO = {
  locationId: number;
  locationType: string | null;
  streetAddress: string | null;
  unitNumber: string | null;
  city: string | null;
  state: string | null;
  zipCode: string | null;
  inactiveDate: string | null;
};

export type Prescription = {
  id: number;
  integrationPrescriptionId: number;
  batchId: string | null;
  tracking: string | null;
  responsePayload: string | null;
  patientId: number;
  patientName: string;
  providerId: number;
  providerName: string;
  locationId: number | null;
  location: PracticeLocationDTO | null;
  practiceId: number;
  documentId: number;
  createdBy: number;
  createdAt: string;
};

type PatientInfoState = {
  patientInfoObject: PatientInfo,
  patientDocumentInfo?: PatientDocumentInfo | null;
  status: LoadingType;
  patientBeneficationSummaryData:patientBeneficationSummaryData[],
  patientActiveBeneficationSummaryData:patientBeneficationSummaryData[],
  patientActiveBeneficationInsuranceSummaryData:patientBeneficationInsuranceSummaryData | null,
  patientList: PatientInfo[],
  searchPatientList: PaginationSearchList | null,
  practiceList: PracticeInfo[];
  patientsByUserRole: PatientInfo[];
  woundInfoHasIvrByPatient: WoundInfoHasIvrByPatient[],
  patientFetchStatus: LoadingType,
  patientListFetchStatus: LoadingType,
  patientListByUserRoleStatus: LoadingType,
  searchPatientListStatus: LoadingType,
  savePatientStatus: LoadingType,
  checkPatientStatus: LoadingType
  getHasWoundInfoIvrStatus: LoadingType,
  saveWoundInfoStatus: LoadingType,
  fetchPatientBenefitSummaryStatus: LoadingType,
  fetchActivePatientBenefitSummaryStatus: LoadingType,
  patientVerificationData:any,
  patientVerificationDataStatus:LoadingType,
  autoPatientVerificationDataStatus:LoadingType,
  AddPatientByEMRCheck?: AddPatientByEMRCheck,
  inactivatePatientWoundStatus: LoadingType,
  patientCreationStatusByEmr: LoadingType,
  patientEmrData: any,
  surgicalTemplateOptions:SurgicalTemplateOptions[]|null
  surgicalTemplate:SurgicalTemplate|null
  prescriptions: Prescription[]|null
}

const initialState = {
  patientInfoObject: {
    patientId: 0,
    name: {
      firstName: "",
      middleName: "",
      lastName: "",
    },
    address: "",
    unitNumber: "",
    city: "",
    state: "",
    zip: "",
    primaryInsurance: "",
    secondaryInsurance: false,
    practiceId: null,
    specialization: null,
    practiceName: "",
    firstName: "",
    middleName: "",
    lastName: "",
    nameList: [],
    birthDate: "",
    gender: "",
    addressInfo: null,
    status: null,
    patientInfo: [],
    patientCode: "",
    patientEmail: "",
    patientName: "",
    dateOfSurgery: "",
    providerId: null,
    providerTemplateId: null,
    insuranceInfo: {
      insuranceName: "",
      insurancePayerCode: "",
      policy: "",
      isPolicyUnderDifferentName: false,
      policyholderFirstName: "",
      policyholderMiddleName: "",
      policyholderLastName: "",
      policyHolderDOB: "",
      insuranceType: "",
      insuranceCards: [],
      isInsuranceCardsSkipped: false,
      isSecondaryInsurance: false,
      secondaryInsuranceName: "",
      secondaryInsurancePayerCode: "",
      secondaryPolicy: "",
      isSecondaryPolicyUnderDifferentName: false,
      secondarypolicyholderFirstName: "",
      secondarypolicyholderMiddleName: "",
      secondarypolicyholderLastName: "",
      secondaryPolicyHolderDOB: "",
      secondaryInsuranceType: "",
      secondaryInsuranceCards: [],
      isSecondaryInsuranceCardsSkipped: false,
    }
  },
  AddPatientByEMRCheck:{
    practiceId: null,
    providerId: null,
    providerTemplateId: null,
    emrPracticeId: null,
    firstName: null,
    lastName: null,
    dateOfBirth: null,
    dateOfSurgery: null,
    emrProviderPracticeId: null,
    emrIntegrationProvider: null,
    providerName: null
  },
  surgicalTemplateOptions:[],
  surgicalTemplate: null,
  patientBeneficationSummaryData: [],
  patientActiveBeneficationSummaryData: [],
  patientActiveBeneficationInsuranceSummaryData:null,
  patientList: [],
  searchPatientList: null,
  practiceList: [],
  patientsByUserRole: [],
  woundInfoHasIvrByPatient: [],
  patientListFetchStatus: "idle",
  patientFetchStatus: "idle",
  patientListByUserRoleStatus: 'idle',
  searchPatientListStatus: 'idle',
  savePatientStatus: 'idle',
  checkPatientStatus: 'idle',
  getHasWoundInfoIvrStatus: 'idle',
  fetchPatientBenefitSummaryStatus: 'idle',
  fetchActivePatientBenefitSummaryStatus: 'idle',
  saveWoundInfoStatus: 'idle',
  patientVerificationData:null,
  patientEmrData:null,
  patientVerificationDataStatus:'idle',
  autoPatientVerificationDataStatus:'idle',
  patientDocumentInfo:undefined,
  inactivatePatientWoundStatus: 'idle',
  patientCreationStatusByEmr: 'idle',
  status: "idle",
  prescriptions: null
} as PatientInfoState;

export const getPatientList = createAsyncThunk("getPatientList", async (undefined, { rejectWithValue }) => {
  try {
    const response = await http.post(FETCH_PATIENTLIST_URL);
    let resp = response.data;
    return resp;
  }
  catch {
    return rejectWithValue("Error while creating the patient")
  }
});

export const getPatient = createAsyncThunk<any, { patientId: string }>("getPatient", async (data, { rejectWithValue }) => {
  let queryParam = "";
  queryParam += `?patientId=${data.patientId}&`;
  try {
    const response = await http.get(FETCH_PATIENT_URL + queryParam);
    let resp = response.data;
    return resp;
  }
  catch {
    return rejectWithValue("Error while creating the patient")
  }
});

export const getPatientWithActivePatientInfo = createAsyncThunk<any, { patientId: string }>("getPatientWithActivePatientInfo", async (data, { rejectWithValue }) => {
  let queryParam = "";
  queryParam += `?patientId=${data.patientId}&`;
  try {
    const response = await http.get(GET_PATIENT_DETAILS_WITH_ACTIVE_PATIENT_INFO + queryParam);
    let resp = response.data;
    return resp;
  }
  catch {
    return rejectWithValue("Error while creating the patient")
  }
});

export const getPatientSaveAuditLog = createAsyncThunk<any, { patientId: string, isSaveAuditLog?: boolean}>("getPatientSaveAuditLog", async (data, { rejectWithValue }) => {
  let queryParam = "";
  queryParam += `?patientId=${data.patientId}&isSaveAuditLog=${data.isSaveAuditLog}`;
  try {
    const response = await http.get(FETCH_PATIENT_URL + queryParam);
    let resp = response.data;
    return resp;
  }
  catch {
    return rejectWithValue("Error while creating the patient")
  }
});

export const deletePatient = createAsyncThunk<any, { patientId: string }>("deletePatient", async (data, { rejectWithValue }) => {
  let queryParam = "";
  queryParam += `?patientId=${data.patientId}&`;
  try {
    const response = await http.delete(DELETE_PATIENT_URL + queryParam);
    let resp = response.data;
    return resp;
  }
  catch {
    return rejectWithValue("Error while creating the patient")
  }
});

export const getPatientListByPracticeId = createAsyncThunk<
  any,
  { practiceId: string }
>("getPatientListByPracticeId", async (data, { rejectWithValue }) => {
  let queryParam = "";
  queryParam += `?practiceId=${data.practiceId}&`;
  try {
    const response = await http.get(
      FETCH_PATIENT_LIST_BY_PRACTICE_ID + queryParam
    );
    let resp = response.data;
    return resp;
  } catch {
    return rejectWithValue("Error while fetching patients");
  }
});

export const checkPatientEligibilty = createAsyncThunk("checkPatientEligibilty", async (pVerifyrequest:any) => {
  const response = await fetchPatientEligibilty(pVerifyrequest);
  const v3Response = response.data;
  return v3Response.data;
});

export const getPatientListByUserRole = createAsyncThunk("getPatientListByUserRole", async () => {
  const response = await fetchPatientsByUserRole();
  const v3Response = response.data;
  return v3Response.data;
});

// CS-1300
export const getPatientListForFilter = createAsyncThunk("getPatientListForFilter", async (arg?: { skipLoader?: boolean }) => {
  const response = await fetchPatientListforFilter(!!arg?.skipLoader);
  const v3Response = response.data;
  return v3Response.data;
});
//
export const searchPatients = createAsyncThunk("searchPatients", async (patientRequest: SearchPatientRequest) => {
  const response = await patientSearchService(patientRequest)
  const v3Response = response.data;
  return v3Response.data;
});

export const createPatient = createAsyncThunk("createPatient", async (patientObj: SavePatientRequest) => {
  const response = await savePatient(patientObj);
  const v3Response = response.data;
  return v3Response;
});

export const checkWoundInfoIvrHasIvr = createAsyncThunk("checkWoundInfoIvrHasIvr", async (patientId: number) => {
  const response = await woundInfoIvrAvailability(patientId);
  const v3Response = response.data;
  return v3Response.data;
});

export const checkPatientExist = createAsyncThunk("checkPatientExist", async (chkPatientObj: CheckPatientRequest) => {
  const response = await checkPatient(chkPatientObj);
  const v3Response = response;
  return v3Response;
});

export const saveWoundInfo = createAsyncThunk("saveWoundInfo", async (woundRequest: SaveWoundInfoRequest) => {
  const response = await saveWoundData(woundRequest);
  const v3Response = response.data;
  return v3Response.data;
});
export const savePatientVerificationData = createAsyncThunk("savePatientVerificationData", async (patientData:any) => {
  const response = await savePatientBeneficationData(patientData);
  const v3Response = response.data;
  return v3Response.data;
});
//CS-1297 - Start - Below action is used to skip loader when auto pVerify is called
export const savePatientVerificationDataSkipLoader = createAsyncThunk(
  "savePatientVerificationDataSkipLoader",
  async (patientData: any) => {
    const response = await savePatientBeneficationData(patientData, {
      headers: { 'x-skip-loader': 'true' }
    });
    return response.data?.data;
  }
);
//CS-1297 - End
export const fetchPatientBeneficationSummaryByPatientId = createAsyncThunk("fetchPatientBeneficationSummaryByPatientId", async( patientId: string ) => {
    const response = await getPatientBeneficationSummary(patientId);
    return response.data;
  })
export const fetchActivePatientBeneficationSummaryByPatientId = createAsyncThunk("fetchActivePatientBeneficationSummaryByPatientId", async( patientId: string ) => {
    const response = await getActivePatientBeneficationSummary(patientId);
    return response.data;
  })
export const fetchActivePatientBeneficationInsuranceSummaryBybvsId = createAsyncThunk("fetchActivePatientBeneficationInsuranceSummaryBybvsId", async( bvsId: string ) => {
    const response = await getActivePatientBeneficationInsruanceSummary(bvsId);
    return response.data;
  })
  export const fetchPatientDocumentsByIds = createAsyncThunk('fetchOrderDocumentsByIds', async (documentIds: number[]) => {
    const response = await getPatientDocumentsByDocumentIds(documentIds);
    const v3Response = response.data;
    return v3Response.data;
  });
  export const changePatientStatus = createAsyncThunk('changePatientStatus', async (patientStatus: PatientStatus) => {
    const response = await updatePatientStatus(patientStatus);
    const v3Response = response.data;
    return v3Response.data;
  });
//CS-1244 - Start
  export const addPatientThorughEMR = createAsyncThunk("addPatientThorughEMR", async (patientEMRData:AddPatientByEMRCheck) => {
  const response = await addPatientByEmrCheck(patientEMRData);
  const v3Response = response.data;
  return v3Response;
});
  export const getSurgicalTemplateBasedOnProvider = createAsyncThunk("getSurgicalTemplateBasedOnProvider", async (providerId:string|number) => {
  const response = await getSurgicalTemplateBasedOnProviderId(providerId);
  const v3Response = response.data;
  return v3Response.data;
});
//CS-1244 - End
  // CS-1158 - START
  export const updatedPatientAddress = createAsyncThunk(
    'updatePatientAddress',
    async ({ patientId, patientAddress }: { patientId: number; patientAddress: any }) => {
      const response = await updatepatintAddress(patientId, patientAddress);
      return response.data;
    }
  );
// CS-1158 - END

export const inactivatePatientWoundInfo = createAsyncThunk('inactivatePatientWoundInfo', async (patientId: number) => {
  const response = await inactivateWoundInfo(patientId);
  const v3Response = response.data;
  return v3Response.data;
});

export const getSurgicalTemplateByTemplateId = createAsyncThunk("getSurgicalTemplateByTemplateId", async (templateId: number) => {
  const response = await fetchSurgicalTemplateByTemplateId(templateId);
  const v3Response = response.data;
  return v3Response.data;
});

export const getPrescriptionsByPatientId = createAsyncThunk("getPrescriptionsByPatientId", async (patientId: number) => {
  const response = await fetchPrescriptionsByPatientId(patientId);
  const v3Response = response.data;
  return v3Response.data;
});

export const getPrescriptionsByProductIdAndPatientId = createAsyncThunk("getPrescriptionsByProductIdAndPatientId", async ({ patientId, productId }: { patientId: number; productId: number }) => {
  const response = await fetchPrescriptionsByProductIdAndPatientId(patientId,productId);
  const v3Response = response.data;
  return v3Response.data;
});

const patientSlice = createSlice({
  name: "patient",
  initialState,
  reducers: {
    updateElementInPatientSlice : updateElementValue,
    //CS-1244 - Start
    updatePatientEMRObjectReducer: (state: any, action) => {
      state.patientEmrData = action.payload
      state.patientCreationStatusByEmr = 'idle'
    },
    resetSurgicalTemplateOptions: (state: any, action) => {
      state.surgicalTemplateOptions = action.payload
      state.status = 'idle'
    },

    //CS-1244 - End
    //CS-1297 - Start
    resetAutoPatientVerificationStatus: (state: any) => {
      state.autoPatientVerificationDataStatus = 'idle'
    },
    //CS-1297 - End
    updatePatientObjectReducer: (state: PatientInfoState, action) => {
      state.patientInfoObject = action.payload
    },
    resetPatientsByUserRole: (state: PatientInfoState) => {
      state.patientsByUserRole = []
      state.patientListByUserRoleStatus = 'idle'
    },
    resetSearchPatientList: (state: PatientInfoState) => {
      state.searchPatientList = null
      state.searchPatientListStatus = 'idle'
    },
    resetPatientListByPracticeId: (state: PatientInfoState) => {
      state.patientList = []
      state.patientListFetchStatus = 'idle'
    },
    resetPatientInfoObject: (state: PatientInfoState) => {
      state.patientInfoObject = initialState.patientInfoObject
      state.patientFetchStatus = 'idle'
    },
    resetPatientActiveBeneficationInsuranceSummaryData: (state: any) => {
      state.patientActiveBeneficationInsuranceSummaryData = initialState.patientActiveBeneficationInsuranceSummaryData
      state.status = 'idle'
    },
    resetSecondaryInsuranceInfo: (state: PatientInfoState) => {
      if (state.patientInfoObject?.insuranceInfo) {
        state.patientInfoObject.insuranceInfo = {
          ...state.patientInfoObject.insuranceInfo,
          secondaryInsuranceName: "",
          secondaryInsurancePayerCode: "",
          secondaryPolicy: "",
          isSecondaryPolicyUnderDifferentName: false,
          secondarypolicyholderFirstName: "",
          secondarypolicyholderMiddleName: "",
          secondarypolicyholderLastName: "",
          secondaryPolicyHolderDOB: "",
          secondaryInsuranceType: "",
          secondaryInsuranceCards: [],
          isSecondaryInsuranceCardsSkipped: false,
        };
      }
    },
    resetProviderTemplate: (state: any) => {
      state.surgicalTemplate = null
    },
    resetPatientActiveBeneficationSummaryData: (state: any) => {
      state.patientActiveBeneficationSummaryData = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPatient.pending, (state) => {
        state.patientListFetchStatus = "loading";
      })
      .addCase(createPatient.fulfilled, (state, action: PayloadAction<PatientInfoResponse>) => {
        state.savePatientStatus = "success";
      })
      .addCase(createPatient.rejected, (state, action) => {
        state.patientListFetchStatus = 'error';
      })
      .addCase(getPatientList.pending, (state) => {
        state.patientListFetchStatus = "loading";
      })
      .addCase(getPatientList.fulfilled, (state, action: PayloadAction<PatientInfoResponse>) => {
        state.patientListFetchStatus = "success";
        // state.patientList = action.payload.data;
        state.patientList = action.payload?.data; // CS-1984
      })
      .addCase(getPatientList.rejected, (state, action) => {
        state.patientListFetchStatus = 'error';
      })
      .addCase(savePatientVerificationData.pending, (state) => {
        state.patientVerificationDataStatus = "loading";
      })
      .addCase(savePatientVerificationData.fulfilled, (state, action: PayloadAction<PatientInfoResponse>) => {
        state.patientVerificationDataStatus =  "success";
        state.patientVerificationData = action.payload;
      })
      .addCase(savePatientVerificationData.rejected, (state, action) => {
        state.patientVerificationDataStatus = 'error';
      })
      //CS-1297 - Start
      .addCase(savePatientVerificationDataSkipLoader.pending, (state) => {
        state.autoPatientVerificationDataStatus = "loading";
      })
      .addCase(savePatientVerificationDataSkipLoader.fulfilled, (state, action: PayloadAction<PatientInfoResponse>) => {
        state.autoPatientVerificationDataStatus =  "success";
        // state.patientVerificationData = action.payload;
      })
      .addCase(savePatientVerificationDataSkipLoader.rejected, (state, action) => {
        state.autoPatientVerificationDataStatus = 'error';
      })
      //CS-1297 - End
      .addCase(getPatient.pending, (state) => {
        state.patientFetchStatus = "loading";
      })
      .addCase(getPatient.fulfilled, (state, action) => {
        state.patientFetchStatus = "success";
        state.patientInfoObject = action.payload.data;
      })
      .addCase(getPatient.rejected, (state, action) => {
        state.patientFetchStatus = 'error';
      })
      .addCase(getPatientSaveAuditLog.pending, (state) => {
        state.patientFetchStatus = "loading";
      })
      .addCase(getPatientSaveAuditLog.fulfilled, (state, action) => {
        state.patientFetchStatus = "success";
        state.patientInfoObject = action.payload.data;
      })
      .addCase(getPatientSaveAuditLog.rejected, (state, action) => {
        state.patientFetchStatus = 'error';
      })
      .addCase(deletePatient.pending, (state) => {
        state.patientListFetchStatus = "loading";
      })
      .addCase(deletePatient.fulfilled, (state, action: PayloadAction<PatientInfoResponse>) => {
        state.patientListFetchStatus = "success";
        // state.patientList = action.payload.data; // CS-1984: guarded below
        state.patientList = action.payload?.data || []; // CS-1984
      })
      .addCase(deletePatient.rejected, (state, action) => {
        state.patientListFetchStatus = 'error';
      })
      .addCase(getPatientListByPracticeId.pending, (state) => {
        state.patientListFetchStatus = "loading";
      })
      .addCase(getPatientListByPracticeId.fulfilled, (state, action: PayloadAction<PatientInfoResponse>) => {
        state.patientListFetchStatus = "success";
        // state.patientList = action.payload.data; // CS-1984: guarded below
        state.patientList = action.payload?.data || []; // CS-1984
      })
      .addCase(getPatientListByPracticeId.rejected, (state, action) => {
        state.patientListFetchStatus = 'error';
      })
      .addCase(getPatientListByUserRole.pending, (state) => {
        state.patientListFetchStatus = "loading";
      })
      .addCase(getPatientListByUserRole.fulfilled, (state, action) => {
        state.patientListByUserRoleStatus = "success";
        state.patientsByUserRole = action.payload;
      })
      .addCase(getPatientListByUserRole.rejected, (state, action) => {
        state.patientListFetchStatus = 'error';
      })
      .addCase(getPatientListForFilter.pending, (state) => {
        state.patientListFetchStatus = "loading";
      })
      .addCase(getPatientListForFilter.fulfilled, (state, action) => {
        state.patientListByUserRoleStatus = "success";
        state.patientsByUserRole = action.payload;
      })
      .addCase(getPatientListForFilter.rejected, (state, action) => {
        state.patientListFetchStatus = 'error';
      })
      .addCase(fetchPatientBeneficationSummaryByPatientId.pending, (state) => {
        state.fetchPatientBenefitSummaryStatus = "loading";
      })
      .addCase(fetchPatientBeneficationSummaryByPatientId.fulfilled, (state, action) => {
        state.fetchPatientBenefitSummaryStatus = "success";
        // state.patientBeneficationSummaryData = action.payload.data; // CS-1984: guarded below
        state.patientBeneficationSummaryData = action.payload?.data || []; // CS-1984
      })
      .addCase(fetchPatientBeneficationSummaryByPatientId.rejected, (state, action) => {
        state.fetchPatientBenefitSummaryStatus = 'error';
      })
      .addCase(fetchActivePatientBeneficationSummaryByPatientId.pending, (state) => {
        state.fetchActivePatientBenefitSummaryStatus = "loading";
      })
      .addCase(fetchActivePatientBeneficationSummaryByPatientId.fulfilled, (state, action) => {
        state.fetchActivePatientBenefitSummaryStatus = "success";
        // state.patientActiveBeneficationSummaryData = action.payload.data; // CS-1984: guarded below
        state.patientActiveBeneficationSummaryData = action.payload?.data || []; // CS-1984
      })
      .addCase(fetchActivePatientBeneficationSummaryByPatientId.rejected, (state, action) => {
        state.fetchActivePatientBenefitSummaryStatus = 'error';
      })
      .addCase(fetchActivePatientBeneficationInsuranceSummaryBybvsId.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchActivePatientBeneficationInsuranceSummaryBybvsId.fulfilled, (state, action) => {
        state.status = "success";
        state.patientActiveBeneficationInsuranceSummaryData = action.payload.data;
      })
      .addCase(fetchActivePatientBeneficationInsuranceSummaryBybvsId.rejected, (state, action) => {
        state.status = 'error';
      })
      .addCase(searchPatients.pending, (state) => {
        state.searchPatientListStatus = "loading";
      })
      .addCase(searchPatients.fulfilled, (state, action) => {
        state.searchPatientListStatus = "success";
        state.searchPatientList = action.payload?.searchPatientData;
      })
      .addCase(searchPatients.rejected, (state, action) => {
        state.searchPatientListStatus = 'error';
      })
      .addCase(checkWoundInfoIvrHasIvr.pending, (state) => {
        state.getHasWoundInfoIvrStatus = "loading";
      })
      .addCase(checkWoundInfoIvrHasIvr.fulfilled, (state, action) => {
        state.getHasWoundInfoIvrStatus = "success";
        state.woundInfoHasIvrByPatient = action.payload;
      })
      .addCase(checkWoundInfoIvrHasIvr.rejected, (state, action) => {
        state.getHasWoundInfoIvrStatus = 'error';
      }) 
      .addCase(saveWoundInfo.pending, (state) => {
        state.saveWoundInfoStatus = "loading";
      })
      .addCase(saveWoundInfo.fulfilled, (state, action) => {
        state.saveWoundInfoStatus = "success";
      })
      .addCase(saveWoundInfo.rejected, (state, action) => {
        state.saveWoundInfoStatus = 'error';
      })      
      .addCase(checkPatientExist.pending, (state) => {
        state.checkPatientStatus = "loading";
      })
      .addCase(checkPatientExist.fulfilled, (state, action) => {
        state.checkPatientStatus = "success";
      })
      .addCase(checkPatientExist.rejected, (state, action) => {
        state.checkPatientStatus = 'error';
      })
      .addCase(fetchPatientDocumentsByIds.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPatientDocumentsByIds.fulfilled, (state, action) => {
        state.status = "success";
        state.patientDocumentInfo = action.payload;
      })
      .addCase(fetchPatientDocumentsByIds.rejected, (state, action) => {
        state.status = "error";
      })  // CS-1158 - START
      .addCase(updatedPatientAddress.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updatedPatientAddress.fulfilled, (state, action) => {
        state.status = "success";
        state.patientDocumentInfo = action.payload;
      }   // CS-1158 - END
      )
      .addCase(updatedPatientAddress.rejected, (state, action) => {
        state.status = "error";
      })
      .addCase(inactivatePatientWoundInfo.pending, (state) => {
        state.inactivatePatientWoundStatus = "loading";
      })
      .addCase(inactivatePatientWoundInfo.fulfilled, (state, action) => {
        state.inactivatePatientWoundStatus = "success";
      })
      .addCase(inactivatePatientWoundInfo.rejected, (state, action) => {
        state.inactivatePatientWoundStatus = "error";
      })
      .addCase(changePatientStatus.pending, (state) => {
        state.checkPatientStatus = "loading";
      })
      .addCase(changePatientStatus.fulfilled, (state, action) => {
        state.checkPatientStatus = "success";
      })
      .addCase(changePatientStatus.rejected, (state, action) => {
        state.checkPatientStatus = 'error';

      })
      .addCase(addPatientThorughEMR.pending, (state) => {
        state.patientCreationStatusByEmr = "loading";
      })
      .addCase(addPatientThorughEMR.fulfilled, (state, action) => {
        state.patientCreationStatusByEmr = "success";
        state.patientEmrData=action.payload;
      })
      .addCase(addPatientThorughEMR.rejected, (state, action) => {
        state.patientCreationStatusByEmr = "error";
      })
      //CS-1244 - Start
      .addCase(getSurgicalTemplateBasedOnProvider.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getSurgicalTemplateBasedOnProvider.fulfilled, (state, action) => {
        state.status = "success";
        state.surgicalTemplateOptions=action.payload;
      })
      .addCase(getSurgicalTemplateBasedOnProvider.rejected, (state, action) => {
        state.status = "error";
      })
      //CS-1244 - End
      .addCase(getSurgicalTemplateByTemplateId.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getSurgicalTemplateByTemplateId.fulfilled, (state, action) => {
        state.status = "success";
        state.surgicalTemplate = action.payload;
      })
      .addCase(getSurgicalTemplateByTemplateId.rejected, (state, action) => {
        state.status = "error";
      })
      .addCase(getPrescriptionsByPatientId.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getPrescriptionsByPatientId.fulfilled, (state, action) => {
        state.status = "success";
        state.prescriptions = action.payload;
      })
      .addCase(getPrescriptionsByPatientId.rejected, (state, action) => {
        state.status = "error";
      });
  },
});

export const { resetAutoPatientVerificationStatus ,resetSurgicalTemplateOptions ,updatePatientObjectReducer, updatePatientEMRObjectReducer,resetPatientsByUserRole, resetSearchPatientList, resetPatientListByPracticeId, resetPatientInfoObject,resetPatientActiveBeneficationInsuranceSummaryData, updateElementInPatientSlice, resetSecondaryInsuranceInfo, resetProviderTemplate, resetPatientActiveBeneficationSummaryData } = patientSlice.actions;

export const usePatientReducer = () => useAppSelector((state) => state.patientSlice);
export default patientSlice.reducer;
